
export const Action_GetAllRoleInUser = "Action_GetAllRoleInUser";
export const Action_GetAllRoleInUserSuccess = "Action_GetAllRoleInUserSuccess";
export const Action_GetAllUser = "Action_GetAllUser";
export const Action_GetAllUserSuccess = "Action_GetAllUserSuccess";
